module.exports = __webpack_public_path__ + "img/city-profile.3b3fb65f.jpg";